var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 section-container"},[_c('h4',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6112de56","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Review/Section.vue
// module id = null
// module chunks = 